<template>
  <div class="sidebar h-full flex border-r">
    <div
      class="content"
      :class="[isMobile ? 'mobile' : isCollapsed ? 'short' : 'full']"
    >
      <UiSidebarHeader class="flex flex-col gap-3.5 mb-3 px-2">
        <AppSidebarHeader
          :isCollapsed="isCollapsed"
          :logo="logoBlue"
          :isMobile="isMobile"
          @toggleSidebarHandler="toggleSidebar"
        />
        <!--TODO: Поиск временно неактивен: глобальный поиск ещё не реализован (нет API/вывода результатов) -->
        <SearchBar :isCollapsed="!isMobile && isCollapsed" />
      </UiSidebarHeader>

      <UiSidebarContent>
        <el-scrollbar>
          <div class="flex-1">
            <NavBar :isCollapsed="isCollapsed" :pages="pages" />
          </div>
        </el-scrollbar>
      </UiSidebarContent>

      <UiSidebarFooter :isCollapsed="isCollapsed" class="px-2">
        <div v-if="!isCollapsed">
          <ProgressBar />
        </div>
        <UserProfile :isCollapsed="isCollapsed" :avatar="human" :user="user" />
      </UiSidebarFooter>
    </div>
  </div>
</template>

<script>
import logo from "/src/assets/styles/logo.png";
import logoBlue from "/src/assets/styles/q-logo-blue.png";
import human from "/src/assets/styles/human.png";
import AppSidebarHeader from "@/widgets/app-sidebar/ui/SidebarHeader.vue";
import SearchBar from "@/widgets/app-sidebar/ui/SearchBar.vue";
import ProgressBar from "@/widgets/app-sidebar/ui/ProgressBar.vue";
import NavBar from "@/widgets/app-sidebar/ui/NavBar.vue";
import UserProfile from "@/widgets/app-sidebar/ui/UserProfile.vue";
import { getMe } from "@/entities/session";
import {
  SidebarHeader as UiSidebarHeader,
  SidebarContent as UiSidebarContent,
  SidebarFooter as UiSidebarFooter,
} from "@/shared/ui/sidebar";

export default {
  name: "LayoutSidebar",
  props: {
    rootRouteName: {
      type: String,
      default: "home",
    },
    isMobile: { type: Boolean, default: false },
  },
  emits: ["close"],
  components: {
    AppSidebarHeader,
    SearchBar,
    ProgressBar,
    NavBar,
    UserProfile,
    UiSidebarHeader,
    UiSidebarContent,
    UiSidebarFooter,
  },
  data() {
    return {
      isCollapsed: localStorage.getItem("is_sidebar_collapsed") === "true",
      logo,
      logoBlue,
      human,
      pageTitle: "",
      pages: [],
      user: null,
      options: [
        { label: "Профиль", actionName: "goToProfile", iconName: "sli-user" },
        { label: "Выйти", actionName: "logout", iconName: "sli-logout" },
      ],
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    rootRouteName() {
      this.getSideBarMenu();
    },
  },
  mounted() {
    this.getMe();
    this.getSideBarMenu();
  },
  methods: {
    async getMe() {
      const data = await getMe();
      if (data && data.payload) {
        this.user = data.payload;
      }
    },
    async getSideBarMenu() {
      const route = this.$router.options.routes.find(
        (r) => r.name === this.rootRouteName
      );
      this.pages = (route?.children || [])
        .filter(
          (button) => button.name && button.meta && button.meta.isDashboardItem
        )
        .map((button) => {
          const children = (button.children || [])
            .filter((c) => c.name && c.meta && c.meta.isSidebarChild)
            .map((c) => ({
              title: c.meta.title || c.meta.heading || "",
              name: c.name,
              icon: c.meta.icon || "",
            }));
          return {
            title: button.meta && button.meta.title,
            name: button.name,
            icon: (button.meta && button.meta.icon) || "",
            badge: (button.meta && button.meta.badge) || "",
            type: (button.meta && button.meta.group) || "",
            children,
          };
        });
    },
    toggleSidebar() {
      if (this.isMobile) {
        this.$emit("close");
        return;
      }
      this.isCollapsed = !this.isCollapsed;
      localStorage.setItem("is_sidebar_collapsed", this.isCollapsed);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  background-color: hsl(var(--sidebar-background));
  border-color: hsl(var(--sidebar-border));
  color: hsl(var(--sidebar-foreground));
}

.content {
  @apply h-full flex flex-col box-border overflow-hidden whitespace-nowrap;
  will-change: width;
  transition: width 0.3s ease;
  padding: 8px 0;
}

.short {
  width: 50px;
}

.full {
  width: 280px;
}

.mobile {
  width: 100%;
}
</style>
